import { useState, useRef, useEffect } from 'react'
import { Form, FormGroup, FormFeedback, Label, Input, Button, Alert } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { getLoginItem, deepEqual, deepCopy, setLoginItem } from '../../utils'
import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { CombinedGraphQLErrors } from '@apollo/client'
import { UPDATE_BASIC_INFO_MUTATION } from '../../graphql.js'
import SuccessMessage from './SuccessMessage'

const UPDATE_BASIC_INFO =  gql(UPDATE_BASIC_INFO_MUTATION)

export default function BasicInformation() {
  console.log('BasicInformation rendered')

  const title = 'Basic Information'
  const initialValues = {
    email: getLoginItem('email'),
    name: getLoginItem('name'),
    cellPhone: getLoginItem('cellPhone')
  }
  const { inputs, handleInputChange } = useForm(initialValues, handleSubmit)
  const initialValuesCopy = deepCopy(initialValues)
  const [savedValues, setSavedValues] = useState(initialValuesCopy)
  const [emailState, setEmailState] = useState({ state: '', message: '' })
  const [nameState, setNameState] = useState({ state: '', message: '' })
  const [cellPhoneState, setCellPhoneState] = useState({ state: '', message: '' })
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true)
  const [alert, setAlert] = useState()
  const [updateBasicInfoMutation] = useMutation(UPDATE_BASIC_INFO)
  const [buttonText, setButtonText] = useState('Save')
  const [success, setSuccess] = useState(false)

  // set the cursor to the "Email" input field
  const emailRef = useRef(null)
  useEffect(() => {
    emailRef.current.focus()
  }, [])

  function handleChange(e) {
    console.log('BasicInformation.handleChange: ', e)
    handleInputChange(e)
    const areEqual = deepEqual(inputs, savedValues)
    console.log({inputs, savedValues, areEqual})
    if ( (saveButtonDisabled && !areEqual) || (!saveButtonDisabled && areEqual) ) {
      setSaveButtonDisabled(!saveButtonDisabled)
    }
  }

  async function handleSubmit() {
    console.log('BasicInformation.handleSubmit: ', inputs)
    setAlert(null)
    let hasErrors = false

    // Email
    if (!inputs.email) {
      hasErrors = true
      setEmailState({ state: 'has-danger', message: 'Email is required' })
    } else {
      if (!inputs.email.includes('@') || !inputs.email.includes('.')) {
        hasErrors = true
        setEmailState({ state: 'has-danger', message: 'Invalid email address' })
      } else {
        setEmailState({ state: '', message: ''})
      }
    }

    // Name
    if (!inputs.name) {
      hasErrors = true
      setNameState({ state: 'has-danger', message: 'Name is required' })
    } else (
      setNameState({ state: '', message: ''})
    )

    // Cell Phone
    if (inputs.cellPhone) {
      console.log(inputs.cellPhone, inputs.cellPhone.length)
      if (inputs.cellPhone.length !== 10) {
        hasErrors = true
        setCellPhoneState({ state: 'has-danger', message: 'Cell Phone must be a 10 digit number only' })
      } else {
        setCellPhoneState({ state: '', message: '' })
      }
    } else {
      setCellPhoneState({ state: '', message: '' })
    }

    // Update the information on the server
    if (!hasErrors) {
      try {
        setButtonText('Saving...')
        await updateBasicInfoMutation({ variables: { inputs: inputs } })
          .then((res) => {
            console.log('BasicInformation.handleSubmit:', res)
            if (res.data.updateBasicInfo === 'SUCCESS') {
              // Update the local storage
              setLoginItem('email', inputs.email)
              setLoginItem('name', inputs.name)
              setLoginItem('cellPhone', inputs.cellPhone)
              setSavedValues(deepCopy(inputs))
              setSaveButtonDisabled(true)
              setSuccess(true)
            }
          })
      } catch (error) {
        if (CombinedGraphQLErrors.is(error)) { 
          const errors = error.errors.map((error) => {
            return error.message
          })
          setAlert(<Alert color="danger">{errors[0]}</Alert>)
        }
      } finally {
        setButtonText('Save')
      }
    }
  }

  if (success) {
    return <SuccessMessage title={title} text={`${title} has been successfully updated.`} handleOk={() => setSuccess(false)} />
  }
  return (
    <div style={{ padding: '20px', backgroundColor: '#F0F2F5', height: '100%' }}>
      <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>{title}</span>
      <Form style={{ paddingTop: '20px', maxWidth: '400px' }}>
        {alert}
        <FormGroup>
          <Label for="email" style={{ fontWeight: 'bold' }}>Email</Label>
          <Input
            innerRef={emailRef}
            name="email"
            defaultValue={inputs.email}
            invalid={emailState.state === 'has-danger'}
            valid={emailState.state === 'has-success'}
            onChange={handleChange}
          />
          <FormFeedback>{emailState.message}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="name" style={{ fontWeight: 'bold' }}>Name</Label>
          <Input
            name="name"
            defaultValue={inputs.name}
            invalid={nameState.state === 'has-danger'}
            valid={nameState.state === 'has-success'}
            onChange={handleChange}
          />
          <FormFeedback>{nameState.message}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="cellPhone" style={{ fontWeight: 'bold' }}>Cell Phone</Label>
          <Input
            name="cellPhone"
            type="number"
            defaultValue={inputs.cellPhone}
            invalid={cellPhoneState.state === 'has-danger'}
            valid={cellPhoneState.state === 'has-success'}
            onChange={handleChange}
            onKeyDown={(e) => (e.key === 'e' || e.key === '-' || e.key === '.') && e.preventDefault()}
          />
          <FormFeedback>{cellPhoneState.message}</FormFeedback>
        </FormGroup>
        <Button disabled={saveButtonDisabled} color="primary" style={{ float: 'right' }} onClick={(e) => handleSubmit(e)}>{buttonText}</Button>
      </Form>
    </div>
  )
}
